import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { BrowserRouter, withRouter } from 'react-router-dom';

// import Navigation from './Navigation';
// import Onboarding from './Onboarding';
// import History from './History';
// import Budget from './Budget';
// import Accounts from './Accounts';
// import AddTransaction from './AddTransaction';
// import EditTransaction from './EditTransaction';
// import Category from './Category';
// import Login from './Login';
import SignUp from './waitlist/SignUp';

const Main = () => {
  return (
    <div>
      <BrowserRouter>
        {/* {window.location.pathname == '/' 
        || window.location.pathname == '/EditTransaction'
        || window.location.pathname == '/waitlist'
        || window.location.pathname == '/waitlist/'
        || window.location.pathname == '/AddTransaction'
         ? (
          <div></div>
        ) : (

          <Navigation key="nav-bar-key" />
        )} */}
        <Switch> {/* The Switch decides which component to show based on the current URL.*/}
          <Route exact path='/' component={SignUp}></Route>
          {/* <Route exact path='/budget' component={Budget}></Route>
          <Route exact path='/history' component={History}></Route>
          <Route exact path='/Accounts' component={Accounts}></Route>
          <Route exact path='/AddTransaction' component={AddTransaction}></Route>
          <Route exact path='/EditTransaction' component={EditTransaction}></Route>
          <Route exact path='/Category' component={Category}></Route>
          <Route exact path='/login' component={Login}></Route> */}
          <Route exact path='/waitlist' component={SignUp}></Route>
          <Route exact path='/waitlist/' component={SignUp}></Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default Main;